import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_TOUR_PROGRAM } from 'Utils/request/requestDictionary';
import type { StopProps } from 'Components/widgets/product-program/ProductProgram';
type GQlProgramProps = {
  title: string;
  stops: Array<StopProps>;
  duration: string;
};
type CMSProps = {
  resortId: string;
  isDetailed: boolean;
  yourItinerary: string;
  tourDurationPlaceholder: string;
  tourDayPlaceholder: string;
  yourExtension: string;
  extensionDurationPlaceholder: string;
  extensionDayPlaceholder: string;
};
type GQLProps = {
  stopover: {
    tour: GQlProgramProps;
    extension: GQlProgramProps;
  };
};
export type ResolvedProps = CMSProps & GQLProps;
export const resolve: Resolve<GQLProps, CMSProps> = async (appContext, props) => {
  const {
    resortId: productId,
    yourItinerary,
    tourDurationPlaceholder,
    tourDayPlaceholder,
    yourExtension,
    extensionDurationPlaceholder,
    extensionDayPlaceholder,
  } = props;
  const query = `query {
    stopover(productId:"${productId}"){
      tour{
        title(message:"${yourItinerary}")
        duration(message:"${tourDurationPlaceholder}")
        stops{
          day(message:"${tourDayPlaceholder}")
          title
          description
        }
      }
      extension{
        title(message:"${yourExtension}")
        duration(message:"${extensionDurationPlaceholder}")
        stops{
          day(message:"${extensionDayPlaceholder}")
          title
          description
        }
      }
    }
  }`;
  return graphQLClient.runQuery(query, appContext, {
    requestName: LINE_TOUR_PROGRAM,
    strictErrors: false,
  });
};
